import { render } from "./WaypointItem.vue?vue&type=template&id=7fe88182"
import script from "./WaypointItem.vue?vue&type=script&lang=js"
export * from "./WaypointItem.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "7fe88182"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7fe88182', script)) {
    api.reload('7fe88182', script)
  }
  
  module.hot.accept("./WaypointItem.vue?vue&type=template&id=7fe88182", () => {
    api.rerender('7fe88182', render)
  })

}

script.__file = "resources/js/Pages/Tour/Partials/CoordinateData/WaypointItem.vue"

export default script